/* eslint-disable no-unused-vars */
// eslint-disable-next-line
import React, { useEffect } from 'react';
import { useSelector, connect } from 'react-redux';
import { changeStepForm, STEPS, changeRutaFormulario } from '../../redux/actions/PasosFormulario';
import { checkCobertura } from '../../redux/actions/Coberturas';
import { checkServicio } from '../../redux/actions/Servicios';
import { checkFrontera } from '../../redux/actions/Fronteras';
import { isLoading } from '../../redux/actions/Loading';
import RowCheckbox from '../utils/RowCheckbox';

const FormCoberturas = ({
    stepFoward,
    stepCotizar,
    stepBackward,
    checkCobertura,
    checkServicio,
    checkFrontera,
}) => {
    const coberturas = useSelector(state => state.coberturas);
    const servicios = useSelector(state => state.servicios);
    const fronteras = useSelector(state => state.fronteras);

   

    const onChangeCoberturas = (event) => {
        let selected = {
            id: event.target.id,
            checked: event.target.checked
        }
        checkCobertura(selected)
    }

    const onChangeServicios = (event) => {
        let selected = {
            id: event.target.id,
            checked: event.target.checked
        }
        checkServicio(selected)
    }

    const onChangeFronteras = (event) => {
        let selected = {
            id: event.target.id,
            checked: event.target.checked
        }
        checkFrontera(selected)
    }

    const renderCoberturas = (
        <>
            <div className="row">
                <div className="col-auto title">
                    <h4>COBERTURAS</h4>
                </div>
            </div>
            <div className="row rule-box">
                <div className="col-lg-12">
                    {
                        coberturas.map(cob => <RowCheckbox onChangeRow={onChangeCoberturas} key={`cob-${cob.Id}`} rule={cob} displayCheckbox={true} hasDay={true} />)
                    }
                </div>
            </div>
        </>
    )

    const renderServicios = (
        <>
            <div className="row">
                <div className="col-auto title">
                    <h4>SERVICIOS</h4>
                </div>
            </div>
            <div className="row rule-box">
                <div className="col-lg-12">
                    {
                        servicios.map(cob => <RowCheckbox onChangeRow={onChangeServicios} key={`ser-${cob.Id}`} rule={cob} displayCheckbox={true} hasDay={true} />)
                    }
                </div>
            </div>
        </>
    )

    const renderFronteras = (
        <>
            <div className="row">
                <div className="col-auto title">
                    <h4>FRONTERAS</h4>
                </div>
            </div>
            <div className="row rule-box">
                <div className="col-lg-12">
                    {
                        fronteras.map(cob => <RowCheckbox onChangeRow={onChangeFronteras} key={`fron-${cob.Id}`} rule={cob} displayCheckbox={true} hasDay={false} />)
                    }
                </div>
            </div>
        </>
    )

    return (
        <div>
            <div className="row">
                <div className="col-md-12">
                    <h2>COBERTURAS Y SERVICIOS ADICIONALES</h2>
                </div>
            </div>
            {(coberturas.length > 0) && renderCoberturas}
            {(servicios.length > 0) && renderServicios}
            {(fronteras.length > 0) && renderFronteras}
            <div className="row">
                <div className="col-md-12 box-buttons">
                    <button className="btn btn-interamerican" onClick={stepBackward}>ANTERIOR</button>
                     <button
                        id="btnCotizar"
                        className="btn btn-interamerican"
                        onClick={stepCotizar}
                        style={{ display: 'none' }}
                    >
                        COTIZAR</button>
                    <button className="btn btn-interamerican" onClick={stepFoward}>RESERVAR</button>
                </div>
            </div>
        </div>
    )
}

const mapDispatchToProps = dispatch => {
    return {
        stepFoward: () => {
            dispatch(changeStepForm({ stepForm: STEPS.DATOS_CLIENTE }))
            window.scrollTo(0, 0);
        },
        stepCotizar: () => {
            dispatch(changeStepForm({ stepForm: STEPS.COTIZAR }));
          //  dispatch(changeRutaFormulario({ stepWay:'WAY_COTIZAR'  }));
            window.scrollTo(0, 0);
        },
        stepBackward: () => {
            dispatch(changeStepForm({ stepForm: STEPS.VEHICULO }))
            window.scrollTo(0, 0);
        },
        checkCobertura: value => dispatch(checkCobertura(value)),
        checkServicio: value => dispatch(checkServicio(value)),
        checkFrontera: value => dispatch(checkFrontera(value)),
        isLoading: value => dispatch(isLoading(value))
    }
}

export default connect(null, mapDispatchToProps)(FormCoberturas);